export default {
    to: "/dashboard/api-authentication",
    order: 3,
    icon: "mdi-login",
    title: "Authentication",
    disabled: false,
    value: 0,
}
